import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, canonical, type = 'website' }) => {
  const siteName = 'Serene Sparkle';
  const defaultDescription = 'Professional cleaning services in London. Residential, commercial, and specialty cleaning. Get a free quote today!';
  const defaultKeywords = 'cleaning service, London, house cleaning, office cleaning, deep cleaning, end of tenancy cleaning, professional cleaners';
  const baseUrl = 'https://serene-world.com';

  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Professional Cleaning Services`;
  const metaDescription = description || defaultDescription;
  const metaKeywords = keywords || defaultKeywords;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      {canonical && <link rel="canonical" href={`${baseUrl}${canonical}`} />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      {canonical && <meta property="og:url" content={`${baseUrl}${canonical}`} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content={siteName} />
    </Helmet>
  );
};

export default SEO;
